import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { url: String };

  // action="modal-content-loader#load"
  async load() {
    const content = document.querySelector(
      `${this.element.dataset.target} .modal-content`,
    );
    // 開くのは data-toggle="modal" に任せていて取得より先に表示されるため、前に開いたアプリの内容を消しておく
    content.replaceChildren();

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) throw new Error(response.statusText);
      content.innerHTML = await response.text();
    } catch (error) {
      console.error(error);
      alertify.error('エラーが発生しました。時間をおいて再度お試しください。');
    }
  }
}
